import { useEffect, useState } from 'react'
import Modal from 'react-modal'
import api from '../../../api'
import Spinner from '../../Spinner'

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		height: '90%',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		borderRadius: 15,
		border: 'none',
		overflowX: 'auto',
	},
	overlay: {
		background: '#00000099',
	},
}

const InfoComponent = ({ title, value }) => {
	return (
		<div className="flex flex-col gap-2 items-start w-full">
			<span>{title}</span>
			<div className='border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full flex items-center justify-between text-wa'>
				<span>{value || 'нет данных'}</span>
			</div>
		</div>
	)
}

export default function ClientInfoModal({ isOpen, onClose, clientCode }) {
	const [clientData, setClientData] = useState({})
	const [isLoading, setIsLoading] = useState(false)
	const [isPlacesLoading, setIsPlacesLoading] = useState(false)
	const [allRegions, setAllRegions] = useState()
	const [allCities, setAllCities] = useState()
	const [allDistricts, setAllDistricts] = useState()
	const [phoneNumberArray, setPhoneNumberArray] = useState([''])

	useEffect(() => {
		if (clientCode) {
			;(async () => {
				setIsLoading(true)
				try {
					api
						.get(
							`BusinessPartners('${clientCode}')?$select=CardName,CardCode,U_Comment,U_PhotoId,U_Salary,U_age_data,FreeText,Frozen,U_workplace,U_Telephone,U_address,U_Respawn,U_Language,U_Gender,U_PS,U_KATM,U_Score,U_MIB,U_Nasiya,U_Created,BPAddresses`,
						)
						.then((res) => {
							const data = JSON.parse(res.data)
							setPhoneNumberArray(
								data.U_Telephone
									? data.U_Telephone.split(' , ').map((item) => item.trim())
									: [''],
							)
							console.log(data)

							setClientData(data)
						})
				} catch (error) {
				} finally {
					setIsLoading(false)
				}
			})()
		}
	}, [clientCode, isOpen])

	useEffect(() => {
		setIsPlacesLoading(true)

		api
			.get('U_ADDRESS_REGION', {
				headers: {
					Prefer: 'odata.maxpagesize=20',
				},
			})
			.then((res) => {
				const result = JSON.parse(res.data).value
				setAllRegions(result || [])
			})

		api
			.get('U_ADDRESS_CITY', {
				headers: {
					Prefer: 'odata.maxpagesize=300',
				},
			})
			.then((res) => {
				const result = JSON.parse(res.data).value
				setAllCities(result || [])
			})

		api
			.get('U_ADDRESS_DISCRTICT', {
				headers: {
					Prefer: 'odata.maxpagesize=3000',
				},
			})
			.then((res) => {
				const result = JSON.parse(res.data).value
				setAllDistricts(result || [])
			})
	}, [])

	useEffect(() => {
		if (
			typeof allRegions === 'object' &&
			typeof allCities === 'object' &&
			typeof allDistricts === 'object'
		) {
			setIsPlacesLoading(false)
		}
	}, [allRegions, allCities, allDistricts])

	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={onClose}
			style={customStyles}
			contentLabel="Create User Modal"
			ariaHideApp={false}
			shouldFocusAfterRender={false}
		>
			{isLoading || isPlacesLoading ? (
				<div className="flex flex-col gap-10 w-[700px] p-8">
					<p className="text-lg text-center font-bold text-blue-900">
						Информация о клиенте
					</p>
					<Spinner />
				</div>
			) : (
				<div className="flex flex-col gap-5 w-[700px] p-8">
					<div className="flex flex-col gap-2">
						<p className="text-lg text-center font-bold text-blue-900">
							Информация о клиенте
						</p>
						<div className="grid grid-cols-3 gap-4">
							<InfoComponent
								title="Фамилия"
								value={clientData.CardName?.split(' ')[0] || ''}
							/>
							<InfoComponent
								title="Имя"
								value={clientData.CardName?.split(' ')[1] || ''}
							/>
							<InfoComponent
								title="Отчество"
								value={clientData.CardName?.split(' ')[2] || ''}
							/>
						</div>
						<div className="h-[1px] bg-black w-full mt-4 mb-2" />
					</div>
					<div className="flex flex-col gap-2">
						<div className="flex flex-col gap-2">
							{clientData.BPAddresses?.length ? (
								clientData.BPAddresses?.map((address, index) => (
									<>
										<p className="text-lg text-center font-semibold text-black mb-2">
											{index === 0 ? 'Адрес проживание' : 'Адрес проживание'}
										</p>
										<div
											key={index}
											className="grid grid-cols-3 grid-rows-2 gap-3"
										>
											<InfoComponent
												title="Область"
												value={
													allRegions.find(
														(region) =>
															Number(region.Code) ===
															Number(address.U_RegionCode),
													)?.Name
												}
											/>
											<InfoComponent
												title="Город | Район"
												value={
													allCities.find(
														(city) =>
															Number(city.Code) === Number(address.U_CityCode),
													)?.Name
												}
											/>
											<InfoComponent
												title="QFY | MFY"
												value={
													allDistricts.find(
														(district) =>
															Number(district.Code) ===
															Number(address.U_DistrictCode),
													)?.Name
												}
											/>
											<InfoComponent
												title="Название улицы"
												value={address.StreetNo}
											/>
											<InfoComponent
												title="Номер дома"
												value={address.BuildingFloorRoom}
											/>
											<InfoComponent
												title="Номер квартиры"
												value={address.U_Apartment}
											/>
										</div>
										<hr />
										<br />
									</>
								))
							) : (
								<>
									<p className="text-lg text-center font-semibold text-black mb-2">
										Адрес проживание
									</p>
									<div className="grid grid-cols-3 grid-rows-2 gap-3">
										<InfoComponent title="Область" value={undefined} />
										<InfoComponent title="Город | Район" value={undefined} />
										<InfoComponent title="QFY | MFY" value={undefined} />
										<InfoComponent title="Название улицы" value={undefined} />
										<InfoComponent title="Номер дома" value={undefined} />
										<InfoComponent title="Номер квартиры" value={undefined} />
									</div>
								</>
							)}
						</div>
					</div>
					<div className="flex flex-col gap-5">
						<div className="h-[1px] bg-black w-full mt-4 mb-2" />
						<p className="text-lg text-center font-semibold text-black">
							Дополнительная информация
						</p>
						<div className="grid grid-cols-2 grid-rows-2 gap-3">
							{phoneNumberArray.length &&
								phoneNumberArray.map((item, index) => (
									<InfoComponent
										key={index}
										title="Телефон номер"
										value={item}
									/>
								))}
							<InfoComponent title="ПИНФЛ" value={clientData.CardCode} />
							<InfoComponent
								title="Пол"
								value={
									clientData.U_Gender === 'Male'
										? 'Мужчина'
										: clientData.U_Gender === 'Female'
											? 'Женщина'
											: ''
								}
							/>
							<InfoComponent title="Комментарий" value={clientData.U_Comment} />
						</div>
					</div>
				</div>
			)}
		</Modal>
	)
}
